module.exports = __webpack_public_path__ + "img/upper_frame_back.342b03b2.png";